
























































































































































































import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import HighlightAnchor from '../../components/HighlightAnchor.vue'
import HelpMessage from '../HelpMessage/HelpMessage.vue'
import Icon from '../Icon/Icon.vue'
import MiniHelpMessage from '../MiniHelpMessage/MiniHelpMessage.vue'
import { FieldData } from "../Pi/types";
import Tags from '../Tags/Tags.vue'
import { TagData } from '../Tags/types'

@Component({
  components: {
    HighlightAnchor,
    HelpMessage,
    Tags,
    MiniHelpMessage,
    Icon,
  },
})
export default class ConfigField extends Vue {
  @Prop({ type: String }) readonly title!: string | undefined

  @Prop({ type: [ String, Function ] }) readonly helpMessage!: string | undefined

  @Prop({ type: String }) readonly miniHelpMessage!: string | undefined

  @Prop({ type: String }) readonly goodExampleText!: string | undefined

  @Prop({ type: String }) readonly badExampleText!: string | undefined

  @Prop({ type: String }) readonly goodExampleTextTitle!: string | undefined

  @Prop({ type: String }) readonly badExampleTextTitle!: string | undefined

  @Prop({ type: String }) readonly instructionLink!: string | undefined

  @Prop({ type: Boolean }) readonly inlineHelpMessage!: string | undefined

  @Prop({ type: Boolean }) readonly inline!: FieldData['inline']

  @Prop({ type: Boolean }) readonly required!: string | undefined

  @Prop({ type: Boolean }) readonly disabled!: string | undefined

  @Prop({ type: Boolean }) readonly valueChanged!: boolean

  @Prop({ type: Array }) readonly tags!: Array<TagData> | undefined

  @Prop({ type: Function }) readonly rollback!: () => void | undefined

  @Prop({ type: Function }) readonly resetToDefault!: () => void | undefined

  @Prop({ type: Function }) readonly disableSetting!: () => void | undefined

  @Prop({ type: Boolean, default: true }) readonly titleVisible!: FieldData['titleVisible']

  @Prop({ type: Boolean, default: true }) readonly supportButtons!: FieldData['supportButtons']

  @Prop({ type: Object }) translationsKeys!: Record<string, string>

  @Prop({ type: String, default: '', required: false }) fieldKey!: string

  @Prop({ type: Boolean, required: false, default: false }) hasAnchor!: FieldData['hasAnchor']

  @Emit()
  disableSettingValueTriggered() {
    return true
  }

  @Emit()
  resetToDefaultTriggered() {
    return true
  }

  @Emit()
  rollbackTriggered() {
    return true
  }

  tariffTag() {
    let tariffAndTag: {
      tag: TagData[],
      tariff: TagData[]
    } = {
      tag: [],
      tariff: []
    };
    if (this.tags !== undefined) {
      this.tags.filter(e => {
        if (e.text === "Starter" || e.text === "Advanced" || e.text === "Ultimate" || e.text === "Brand") {
          tariffAndTag.tariff = [ e ]
        } else {
          tariffAndTag.tag = [ e ]
        }
      })
    }
    return tariffAndTag
  }

  openConfirmDialog(settings: {
    title: string,
    text: string,
    onAccept: () => any,
    icon: string
  }): void {
    const { title, text, onAccept, icon } = settings

    this.$confirm({
      title,
      content: text,
      okText: this.$t('config_field_dialog_confirm_accept').toString(),
      cancelText: this.$t('config_field_dialog_confirm_reject').toString(),
      onOk() {
        onAccept()
      },
      centered: true,
      icon,
    })
  }

  disableSettingHandler() {
    if (this.disableSetting) {
      this.disableSetting()
      this.disableSettingValueTriggered()
    }
  }

  resetToDefaultHandler(): void {
    this.openConfirmDialog({
      title: this.$t('config_field_reset_to_default_dialog_title').toString(),
      text: this.$t('config_field_reset_to_default_dialog_text').toString(),
      onAccept: () => {
        if (this.resetToDefault) {
          this.resetToDefault()
          this.resetToDefaultTriggered()
        }
      },
      icon: 'safety-certificate',
    })
  }

  rollbackHandler(): void {
    this.openConfirmDialog({
      title: this.$t('config_field_rollback_dialog_title').toString(),
      text: this.$t('config_field_rollback_dialog_text').toString(),
      onAccept: () => {
        if (this.rollback) {
          this.rollback()
          this.rollbackTriggered()
        }
      },
      icon: 'undo',
    })
  }

  translationKeyIfExists(key: string) {
    return this.translationsKeys?.[key] ?? ''
  }

  created(): void {
    this.$i18n.mergeLocaleMessage('ru', {
      config_field_button_reset_settings_title: 'Выставить по умолчанию',
      config_field_button_roll_back_settings_title: 'Отменить изменения',
      config_field_dialog_confirm_accept: 'Принять',
      config_field_dialog_confirm_reject: 'Отклонить',
      config_field_reset_to_default_dialog_title: 'Выставить настройки по умолчанию',
      config_field_reset_to_default_dialog_text: 'Вы уверены, что хотите выставить настройки по умолчанию?',
      config_field_rollback_dialog_title: 'Отменить изменения',
      config_field_rollback_dialog_text: 'Вы уверены, что хотите отменить изменения?',
    })
    this.$i18n.mergeLocaleMessage('en', {
      config_field_button_reset_settings_title: 'Set as default',
      config_field_button_roll_back_settings_title: 'Cancel changes',
      config_field_dialog_confirm_accept: 'Accept',
      config_field_dialog_confirm_reject: 'Reject',
      config_field_reset_to_default_dialog_title: 'Set default settings',
      config_field_reset_to_default_dialog_text: 'Are you sure you want to use the default settings?',
      config_field_rollback_dialog_title: 'Cancel changes',
      config_field_rollback_dialog_text: 'Are you sure you want to discard your changes?',
    })
  }
}
